import { StyleSheet, Document, Page, Text, View } from '@react-pdf/renderer'
import React from 'react'
import HeaderOfPDF from './Header'
import FooterOfPDF from './Footer'
import { OpForPDFType } from '../Modals/ViewPCP/GeneratePDFModal'
import { SectionTitle } from './SectionTitle'
import MainFieldsOfPDF from './MainFields'

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    paddingTop: 80,
    paddingBottom: 60,
    paddingHorizontal: 40,
  },
  section: {
    marginBottom: 30,
    paddingBottom: 15,
    borderBottom: '1px solid #e0e0e0',
  },
  paragraph: {
    marginBottom: 15,
    fontSize: 10,
    lineHeight: 1.4,
    color: '#666',
  },
  materialItem: {
    marginBottom: 12,
    paddingHorizontal: 15,
    paddingVertical: 8,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
    // borderLeft: '3px solid #007bff',
  },
  serviceItem: {
    marginBottom: 15,
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
    // borderLeft: '3px solid #28a745',
  },
  label: {
    fontWeight: 'bold',
    marginBottom: 3,
    fontSize: 9,
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  value: {
    marginBottom: 4,
    fontSize: 10,
    color: '#555',
    lineHeight: 1.3,
  },
  emptyMessage: {
    fontSize: 10,
    color: '#999',
    fontStyle: 'italic',
    textAlign: 'center',
    paddingVertical: 20,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
  },
})


interface BodyOfPDFType {
  data?: OpForPDFType | null
}

const BodyOfPDF: React.FC<BodyOfPDFType> = ({ data }) => {
  
  const pushFields = (): {label: string, subLabel?: string, value: string}[] => {
    return [
      ...(data?.orderItem.length ? [{
        label: 'Comprimento',
        value: `${data.orderItem.length}mm`
      }] : []),
      ...(data?.orderItem.diameter ? [{
        label: 'Diâmetro',
        value: `${data.orderItem.diameter}mm`
      }] : []),
      ...(data?.orderItem.thickness ? [{
        label: 'Espessura',
        value: `${data.orderItem.thickness}mm`
      }] : []),
      ...(data?.orderItem.width ? [{
        label: 'Largura',
        value: `${data.orderItem.width}mm`
      }] : []),
      ...(data?.orderItem.weight ? [{
        label: 'Peso',
        value: `${data.orderItem.weight}kg`
      }] : [])
    ]
  }
  
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <HeaderOfPDF />
        <SectionTitle title={`${data?.codeOfOP}`} />
        <MainFieldsOfPDF infoFields={[{
          label: 'Produto',
          subLabel: 'Item da venda',
          value: data?.orderItem.ploomesProductName || '',
        }, ...pushFields()]} />
        <View style={styles.section}>
          {data?.stockInProduction?.map((stock, index) => (
            <View key={index} style={styles.materialItem}>
              <Text style={styles.label}>Material:</Text>
              <Text style={styles.value}>{stock.stock.description}</Text>
              <Text style={styles.label}>Quantidade:</Text>
              <Text style={styles.value}>{stock.usedQuantity} {stock.usedUnitOfMeasurement.toLowerCase()}</Text>
            </View>
          )) || <Text style={styles.emptyMessage}>Nenhum material requisitado.</Text>}
        </View>

        <View style={styles.section}>
          {data?.service_stage?.map((service, index) => (
            <View key={index} style={styles.serviceItem}>
              <Text style={styles.label}>Serviço:</Text>
              <Text style={styles.value}>{service.stage.name} #0{(index + 1) * 10}</Text>
              <Text style={styles.label}>Descrição:</Text>
              <Text style={styles.value}>{service.description}</Text>
              {service.observation && (
                <>
                  <Text style={styles.label}>Observações:</Text>
                  <Text style={styles.value}>{service.observation}</Text>
                </>
              )}
            </View>
          )) || <Text style={styles.emptyMessage}>Nenhum serviço especificado.</Text>}
        </View>
        <FooterOfPDF />
      </Page>
    </Document>
  )
}

export default BodyOfPDF